import { FC } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import BaseItem, { BaseItemProps } from './BaseItem';

interface RadioOptionProps {
  v: string | number;
  t: string | React.ReactNode;
}

interface RadioProps extends BaseItemProps {
  options: RadioOptionProps[];
  onChange?: (e: RadioChangeEvent) => void;
}

const RadioItem: FC<RadioProps> = (props) => {
  const { options, onChange, ...rest } = props;
  return (
    <BaseItem {...rest}>
      <Radio.Group onChange={onChange}>
        {options.map((item) => (
          <Radio value={item.v} key={item.v}>
            {item.t}
          </Radio>
        ))}
      </Radio.Group>
    </BaseItem>
  );
};

export default RadioItem;
